import React from "react";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { downloadUsers } from "../../redux/userSpeaker/userSpeakerSlice";

const ExportUsersComponent = ({
    locationId = "",
    roleId = "",
}) => {

    const dispatch = useDispatch();

    const { downloadUsersLoading } = useSelector(
        (state) => state.speaker
    );

    const handleExport = async () => {

        try {

            await dispatch(
                downloadUsers({
                    locationId,
                    roleId,
                })
            ).unwrap();

            toast.success(
                "Users exported successfully"
            );

        } catch (err) {

            console.error(err);

            toast.error(
                err?.message ||
                "Export failed"
            );
        }
    };

    return (
        <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
            onClick={handleExport}
            disabled={downloadUsersLoading}
        >
            <Icon icon="mdi:file-excel-outline" />

            {downloadUsersLoading
                ? "Exporting..."
                : "Users"}
        </button>
    );
};

export default ExportUsersComponent;